const OverallRatingsParse = () => (
    <div>
        You tried to edit the cycle with an unsupported overall ratings configuration. We will investigate the issue,
        but it would help us if you could take a screenshot of your configuration. You can send it to{' '}
        <a href="mailto:support@small-improvements.com">support@small-improvements.com</a>.
    </div>
);

export default {
    REVIEW_CYCLE_OVERALL_RATING_PARSE_EXCEPTION: OverallRatingsParse,
};
